/**
 * Himalayan Pansar Store - Products Data
 * All live products are dynamically managed via Admin Panel and stored in Hostinger MySQL Database.
 */

export const INITIAL_PRODUCTS = [];
